import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import React, { useRef, useEffect } from 'react';
import { classNames } from '../../../../utils/common/styling.js';
import { styles } from './TextAreaWithAutoHeight.styles.js';
import { checkIsFunction } from '../../../../utils/common/dataTypes/function.js';
import { setHeightOfTextArea } from '../../../../utils/common/FormInputs/TextArea/TextAreaWithAutoHeight.js';

var TextAreaWithAutoHeight = function (_a) {
    var onChange = _a.onChange, _b = _a.classes, classes = _b === void 0 ? {} : _b, _c = _a.overrideClasses, overrideClasses = _c === void 0 ? {} : _c, defaultValue = _a.defaultValue, inputRef = _a.inputRef, extras = _a.extras, rest = __rest(_a, ["onChange", "classes", "overrideClasses", "defaultValue", "inputRef", "extras"]);
    var localRef = useRef();
    useEffect(function () {
        /**
         * Due to improper size change function without using resizeObserver in webapp side it was
         * taking random size by default so the proper way of doing it is with resizeObserver hook by js
         * */
        var observer = new ResizeObserver(function () {
            if (localRef === null || localRef === void 0 ? void 0 : localRef.current) {
                setHeightOfTextArea(localRef.current);
            }
        });
        /**
         * Assiging the localRef to start observing the change in size of height of TextArea.
         */
        if (localRef === null || localRef === void 0 ? void 0 : localRef.current) {
            observer.observe(localRef.current);
        }
        setTimeout(function () {
            // This bring cursor to the end of the input text on mount of the component.
            // This is helpful when `autoFocus` prop is passed as true to this component.
            if (localRef === null || localRef === void 0 ? void 0 : localRef.current) {
                localRef.current.selectionStart = localRef.current.selectionEnd = "".concat(defaultValue || "").length;
            }
        }, 0);
        /**
         * On Component UnMount removing the resizeObserver to clear unnecessary
         * computations and observation by resizeObserver.
         */
        return function () {
            if (localRef.current) {
                observer.unobserve(localRef.current);
            }
        };
    }, [localRef]);
    return (React.createElement("div", { className: overrideClasses.root || classNames(styles.root, classes.root) },
        React.createElement("textarea", __assign({ ref: function (element) {
                // why this is done - https://stackoverflow.com/a/65877297
                if (localRef) {
                    localRef.current = element !== null && element !== void 0 ? element : undefined;
                }
                if (typeof inputRef === "function") {
                    inputRef(element);
                }
                else if (inputRef) {
                    inputRef.current = element;
                }
            }, className: overrideClasses.textArea ||
                classNames(styles.textArea, classes.textArea), onChange: function (e) {
                setHeightOfTextArea(e.target);
                if (checkIsFunction(onChange)) {
                    onChange(e);
                }
            }, defaultValue: defaultValue }, rest)),
        extras));
};

export { TextAreaWithAutoHeight as default };
//# sourceMappingURL=TextAreaWithAutoHeight.js.map
